<template>
  <div
    class="toggle-wrapper"
    :class="{ 'toggle--compact': compact }"
    @mouseenter="showTooltip"
    @mouseleave="hideTooltip"
  >
    <div :class="`form-check-${placement} form-switch`">
      <input
        :class="`form-check-input ${placement !== 'right' ? 'me' : 'ms'}-2`"
        type="checkbox"
        :disabled="disabled"
        :checked="value"
        @input="$emit('input', $event.target.checked)"
        @change="handleChange"
      />
      <label v-if="label"> {{ label }} </label>
    </div>
    <div
      v-if="tooltipVisible && displayTooltip"
      class="tooltip"
      :data-position="tooltipPosition"
      v-html="sanitizedTooltip"
    ></div>
  </div>
</template>

<script>
import { Helper } from '@/mixin/helper'

export default {
  mixins: [Helper],
  props: {
    label: { type: String, required: false },
    placement: { type: String, required: false, default: 'right' },
    disabled: { type: Boolean, default: false },
    value: {
      type: Boolean,
    },
    displayTooltip: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
    },
    tooltipPosition: {
      type: String,
      default: 'left',
      validator: (value) => ['top', 'right', 'bottom', 'left'].includes(value),
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checked: this.value,
      tooltipVisible: false,
    }
  },
  computed: {
    sanitizedTooltip() {
      return this.sanitizeHTML(this.tooltipText)
    },
  },
  methods: {
    handleChange(event) {
      this.$emit('change', event.target.checked)
    },
    showTooltip() {
      this.tooltipVisible = true
    },
    hideTooltip() {
      this.tooltipVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle-wrapper {
  position: relative;
  display: inline-block;
}

.toggle--compact {
  .form-switch {
    align-items: center;
    display: flex;
  }

  .form-switch label {
    margin-bottom: 0;
    line-height: 1.2;
  }
}

.tooltip {
  position: absolute;
  background-color: $mep-color-text-400;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  visibility: visible;
  opacity: 1;
  transition: 0.3s;

  &[data-position='left'] {
    right: calc(100% + 5px);
    top: 50%;
    transform: translateY(-50%);
  }

  &[data-position='right'] {
    left: calc(100% + 5px);
    top: 50%;
    transform: translateY(-50%);
  }

  &[data-position='top'] {
    bottom: calc(100% + 5px);
    left: 50%;
    transform: translateX(-50%);
  }

  &[data-position='bottom'] {
    top: calc(100% + 5px);
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
